import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, UserPlus } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { useContentBlocks } from "../../hooks/useContentBlocks";
import { pickBlock } from "../../helpers/contentHelpers";

const CandidateCTA = ({ sectionData }) => {
  const { t, language } = useLanguage();
  const pick = (en, ja, key) => (language === "ja" && ja) ? ja : (en ?? t(key));

  // Fetch feature content blocks for this CTA section
  const sectionId = sectionData?.id;
  const { blocks: featureBlocks } = useContentBlocks(sectionId, "candidate-cta", "feature");

  const label    = pick(sectionData?.labelEn,    sectionData?.labelJa,    "landing.candidateCta.label");
  const title    = pick(sectionData?.titleEn,    sectionData?.titleJa,    "landing.candidateCta.title");
  const subtitle = pick(sectionData?.subtitleEn, sectionData?.subtitleJa, "landing.candidateCta.subtitle");
  const buttonText = pick(sectionData?.ctaButtonEn, sectionData?.ctaButtonJa, "landing.candidateCta.button");

  return (
    <section className="py-12 bg-accent-green/10 border-y border-accent-green/20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div>
            <p className="text-[10px] font-black uppercase tracking-[0.25em] text-accent-green mb-1">
              {label}
            </p>
            <h3 className="text-2xl font-bold text-slate-900">
              {title}
            </h3>
            <p className="text-slate-600 text-sm mt-1">
              {subtitle}
            </p>
          </div>
          <Link
            to="/apply"
            className="shrink-0 bg-subidha-blue hover:bg-slate-900 text-white font-bold px-8 py-4 rounded-full inline-flex items-center gap-3 transition-all shadow-xl hover:scale-105"
          >
            <UserPlus className="w-5 h-5" />
            {buttonText}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Dynamic feature highlights */}
        {featureBlocks.length > 0 && (
          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
            {featureBlocks.map((block) => {
              const picked = pickBlock(block, language);
              return (
                <div
                  key={block.id}
                  className="bg-white/80 backdrop-blur-sm rounded-xl px-4 py-3 text-center border border-accent-green/10"
                >
                  {picked.value && (
                    <p className="text-accent-green font-black text-lg">{picked.value}</p>
                  )}
                  <p className="text-slate-700 text-xs font-bold">{picked.label}</p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default CandidateCTA;
